<template>
  <div class="phone-prefix-select" :class="{ open: open }">
    <input
      ref="input"
      type="text"
      class="field-input prefix-input"
      :value="displayText"
      @focus="openDropdown"
      @input="onSearchInput"
      @keydown.down.prevent="moveHighlight(1)"
      @keydown.up.prevent="moveHighlight(-1)"
      @keydown.enter.prevent="selectHighlighted"
      @keydown.esc.prevent="closeDropdown"
      placeholder="Search code"
    />
    <span class="select-arrow">&#9662;</span>
    <div v-if="open" class="prefix-dropdown">
      <button
        v-for="(code, index) in filteredCountryCodes"
        :key="code.value + '-' + code.label"
        type="button"
        class="prefix-option"
        :class="{ highlighted: index === highlightedIndex }"
        @mousedown.prevent="selectCode(code)"
      >
        {{ code.label }}
      </button>
      <div v-if="!filteredCountryCodes.length" class="no-results">No results</div>
    </div>
  </div>
</template>

<script>
import countryCodes from '../constants/countryCodes'

export default {
  name: 'PhonePrefixSelect',
  props: {
    value: { type: String, default: '+61' }
  },
  data () {
    return {
      open: false,
      search: '',
      highlightedIndex: 0,
      countryCodes: countryCodes
    }
  },
  computed: {
    normalizedValue () {
      return this.value || '+61'
    },
    selectedCode () {
      var selected = this.countryCodes.find(code => code.value === this.normalizedValue)
      return selected || { value: this.normalizedValue, label: this.normalizedValue }
    },
    displayText () {
      return this.open ? this.search : this.selectedCode.label
    },
    filteredCountryCodes () {
      var query = this.search.trim().toLowerCase()
      if (!query) return this.countryCodes

      var digits = query.replace(/\D+/g, '')
      return this.countryCodes.filter(function (code) {
        var label = String(code.label || '').toLowerCase()
        var value = String(code.value || '')
        return label.indexOf(query) !== -1 ||
          value.indexOf(query) !== -1 ||
          (digits && value.replace('+', '').indexOf(digits) !== -1)
      })
    }
  },
  watch: {
    filteredCountryCodes () {
      if (this.highlightedIndex >= this.filteredCountryCodes.length) {
        this.highlightedIndex = 0
      }
    }
  },
  mounted () {
    document.addEventListener('mousedown', this.onDocumentMouseDown)
  },
  beforeDestroy () {
    document.removeEventListener('mousedown', this.onDocumentMouseDown)
  },
  methods: {
    openDropdown () {
      this.open = true
      this.search = ''
      this.highlightedIndex = 0
    },
    closeDropdown () {
      this.open = false
      this.search = ''
    },
    onSearchInput (event) {
      this.search = event.target.value
      this.highlightedIndex = 0
    },
    moveHighlight (step) {
      if (!this.open) {
        this.openDropdown()
        return
      }
      var total = this.filteredCountryCodes.length
      if (!total) return
      this.highlightedIndex = (this.highlightedIndex + step + total) % total
    },
    selectHighlighted () {
      if (!this.open) {
        this.openDropdown()
        return
      }
      var code = this.filteredCountryCodes[this.highlightedIndex]
      if (code) this.selectCode(code)
    },
    selectCode (code) {
      this.$emit('change', code.value)
      this.closeDropdown()
      this.$nextTick(() => {
        if (this.$refs.input) this.$refs.input.blur()
      })
    },
    onDocumentMouseDown (event) {
      if (!this.$el || this.$el.contains(event.target)) return
      this.closeDropdown()
    }
  }
}
</script>

<style scoped>
.phone-prefix-select {
  position: relative;
  color: #1e336f;
}
.prefix-input {
  width: 100%;
  min-height: 44px;
  padding: 10px 30px 10px 12px;
  font-size: 15px;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #fff;
  color: #1e336f;
  outline: none;
  transition: border-color .2s, box-shadow .2s;
  cursor: pointer;
}
.prefix-input:focus {
  border-color: #1e336f;
  box-shadow: 0 0 0 3px rgba(30,51,111,.12);
}
.prefix-input::placeholder {
  color: #9aa8bf;
}
.open .prefix-input {
  border-color: #1e336f;
  box-shadow: 0 0 0 3px rgba(30,51,111,.12);
  padding-right: 30px;
}
.select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #7b8fb8;
  font-size: 12px;
  transition: transform .2s;
}
.open .select-arrow {
  transform: translateY(-50%) rotate(180deg);
}
.prefix-dropdown {
  position: absolute;
  z-index: 30;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #d4ddec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(30, 51, 111, .16);
}
.prefix-option {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  background: #fff;
  color: #1e336f;
  font-size: 14px;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
}
.prefix-option:hover,
.prefix-option.highlighted {
  background: #eef3ff;
}
.prefix-option + .prefix-option {
  border-top: 1px solid #f3f5f8;
}
.no-results {
  padding: 12px;
  color: #7b8fb8;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/PhonePrefixSelect.vue